<template>
  <div>
    <Modal
      v-model="openWindow"
      title="选择需要上传的文件"
      :draggable="true"
      footer-hide
      width="400"
    >
      <div class="pic_question" id="vm">
        <input
          @change="fileChange($event)"
          type="file"
          id="upload_file123"
          ref="upload_file123"
          multiple
          hidden
          accept=".xlsx"
        />
        <h2 style="font-size: 18px">未下载模板</h2>
        <p style="font-size: 14px">
          导入必须用指定模板，还没模板可点击这里<Button
            type="text"
            @click="downLoad"
            >下载模板</Button
          >
        </p>
        <h2 style="margin-top: 20px; margin-bottom: 10px; font-size: 18px">
          已下载模板
        </h2>

        <span style="font-size: 14px; margin-right: 10px">
          {{ file.name }}
        </span>
        <Button
          type="error"
          v-if="file.name.length > 0"
          size="small"
          @click="clear"
          >清空文件</Button
        >
        <Button
          @click="open"
          v-if="file.name.length == 0"
          type="primary"
          ghost
          size="small"
          >选择文件</Button
        >
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="clickCancel123">取消</Button>
              <Button type="primary" @click="daoru">提交</Button>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
    <Modal
      v-model="openDaoruYichang"
      :title="failTitle"
      :mask-closable="false"
      footer-hide
      width="700"
      height="400"
    >
      <Table
        border
        :columns="colyichang"
        :data="yichangData"
        no-data-text="<div class='table-no-data'></div>"
        :height="300"
      ></Table>
    </Modal>
  </div>
</template>
<script>
//multiple

export default {
  data() {
    return {
      imgList: [],
      size: 0,
      limit: 6, //限制图片上传的数量
      tempImgs: [],
      isCamera: true,
      mode: true,
      file: {
        name: "",
      },
      openWindow: false,
      template: "",
      openDaoruYichang: false,
      colyichang: [
        {
          title: "异常行号",
          key: "num",
        },
        {
          title: "异常描述",
          key: "failDesc",
        },
      ],
      yichangData: [],
      failTitle: "",
    };
  },
  methods: {
    openWin(v) {
      this.temUrl = v.temUrl;
      this.url = v.url;
      this.openWindow = true;
    },
    open() {
      //document.getElementById("upload_file123").click();
      this.$refs.upload_file123.click();
    },
    clear666() {
      this.$refs.upload_file123.files = null;

      //let d=this.$refs.upload_file123.files;

      //console.log(d);
      this.template = "";
      this.file.name = "";
    },
    fileChange666(v) {
      //var d = document.getElementById("upload_file123").files[0];
      var d = this.$refs.upload_file123.files[0];
      console.log(d);
      //console.log(this.$refs.upload_file123.files);
      this.template = d;
      this.file.name = d.name;
    },
    // 文件选择后触发
    fileChange(e) {
      const files = e.target.files;
      if (!files.length) return;
      console.log("选择的文件：", files);
      this.template = files[0];
      this.file.name = files[0].name;
      // 你自己的文件处理逻辑
    },

    clear() {
      // 1. 获取DOM元素
      const fileInput = this.$refs.upload_file123;
      if (!fileInput) return;

      // 2. 清空文件（两种写法都可以，推荐第一种兼容最好）
      fileInput.value = "";
      this.template = "";
      this.file.name = "";
      // 或者：fileInput.value = null;

      // 3. 如果你有绑定文件数据，一并清空
      // this.uploadFile = null;
      // this.fileList = [];
    },
    downLoad() {
      this.utils.downLoad(this.temUrl);
    },
    clickCancel123() {
      this.openWindow = false;
      this.clear();
      // document.getElementById("upload_file123").reset();
    },
    daoru() {
      if (this.template.length == 0) {
        this.$Message.error({
          content: "请先选择文件",
          duration: 2,
        });
        return;
      }
      let params = new window.FormData();
      params.append("template", this.template);
      this.clear();
      //this.utils.loading(this, "导入中");
      this.axios({
        method: "post",
        url: this.url,
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        console.log("导入结果", res);
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        } else {
          this.clickCancel123();
          //this.yichangData = res.data.data.failItemList;
          /* this.$Message.success({
            content: "成功导入" + res.data.data.success + "条数据",
            duration: 2,
          });
          if (this.yichangData.length > 0) {
            this.openDaoruYichang = true;
            this.failTitle = "导入异常数据(" + res.data.data.fail + ")";
          } */
          this.$emit("finesh");
        }
      });
    },
  },
};
</script>
<style scoped>
/* 拍照 上传图片--------------------------------- */
.pic_question {
  padding: 0 0.48rem;
}

.add-image {
  float: left;
  width: 60px;
  height: 60px;
  font-size: 60px;
  color: #868686;
  position: relative;
  border: 1px solid #7a7a7a;
  text-align: center;
  line-height: 2.8rem;
  font-weight: lighter;
}

.img-list {
  flex-wrap: wrap;
  float: left;
}

.img-list > li {
  width: 60px;
  height: 60px;
  position: relative;
  margin-right: 10px;
  margin-bottom: 10px;
  display: inline-block;
}
.img-list > li .del {
  position: absolute;
  top: -8px;
  right: -4px;
  color: #2c2c2c;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  opacity: 0.5;
  font-size: 24px;
}
.img-list > li > img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/xiyang/common/daoRuWl.vue